import { useClassroomsUser } from "@app/hooks/users";
import React from "react";
import { TVSchoolTeacherMainPage } from "./tvschool";

export const TeacherClassroomsPage: React.FC<{}> = () => {
	const user = useClassroomsUser();
	if (!user) return null;
	return <TVSchoolTeacherMainPage user={user} />;
};
